import { createGlobalStyle } from 'styled-components';

// Define theme constants
export const theme = {
  palette: {
    primary: { dark: '#152837', light: '#F4F7FB' },
    common: { white: '#fff', black: '#000' },
    text: { dark: '#273E52', main: '#555', light: '#979797' },
    secondary: { light: '#789BB6' },
    background: { dark: '#f9f9f9', transparent: 'transparent', light: '#f5f5f5' },
    accent: { dark: '#FF5900' },
    border: { darker: '#aaa', dark: '#ccc', light: '#ddd' },
    success: { dark: '#57AC2D', light: '#F7FFF3' },
    danger: { dark: '#f00' },
    info: { darker: '#2C3E50', dark: '#556BB8' },
    boxShadow: { main: '#dadada' },
  },
  typography: { fontFamily: 'Open Sans', fontSize: '16px', fontWeight: 'normal' },
};

// Global styles if needed
export const GlobalStyles = createGlobalStyle`
    body {
        font-family: ${theme.typography.fontFamily};
        font-size: ${theme.typography.fontSize};
        overflow: hidden;
    }

    .error-border {
        border: 1px solid red !important;
    }

    /*------ Common classes starts here -----*/
    .flex-auto-grow {
        flex: 1 1 0;
    }

    .fa-dark-grey {
        color: ${theme.palette.border.darker};
    }

    .error-message {
        font-size: 12px;
        font-weight: 400;
        color: ${theme.palette.danger.dark};
    }

    .error-border {
        border: 1px solid ${theme.palette.danger.dark};
    }

    .padding-right-0 {
        padding-right: 0px;
    }

    .no-border {
        border: none;
    }

    .clickable {
        cursor: pointer;
    }

    .not-allowed {
        cursor: not-allowed;
    }

    .unclickable {
        cursor: default !important;
    }

    .no-padding {
        padding: 0px;
    }

    .text-left {
        text-align: left !important;
    }

    .text-center {
        text-align: center !important;
    }

    .text-right {
        text-align: right !important;
    }

    .semi-bold {
        font-weight: 600;
    }

    .font-bold {
        font-weight: 700;
    }

    .font-regular {
        font-weight: 400;
    }

    input::placeholder {
        color: #aaa;
    }

    .single-select-wrapper {
        .header {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 50px;
            cursor: pointer;

            &::placeholder {
                color: #aaa;
            }
        }

        .options-menu li:hover {
            background-color: #f8f8f8;
        }

        input.searchable-dropdown-input {
            width: 100%;
            border: none;
            border-bottom: 1px solid #ccc;
            border-radius: 0px;
            padding: 0px 0px 0px 16px !important;
        }
    }

    .position-relative {
        position: relative;
    }

    .error-message, .error-border {
        margin-bottom: 0px;
        border-radius: 4px;
    }

    .overflow-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 100%;
        width: auto;
    }

    .text-green {
        color: #57ac2d;
    }

    .full-width {
        width: 100%;
    }

    .full-height {
        height: 100%;
    }

    .half-width {
        width: 50%;
    }

    .bg-white {
        background-color: #fff;
    }

    .vertical-align-middle {
        vertical-align: middle;
    }
    .vertical-align-top {
        vertical-align: top;
    }

    .color-outer-input {
        border: 1px solid #aaa;
        border-radius: 4px;
        position: relative;
        height: 42px;
    }

    .color-outer-input input {
        border: 0;
    }

    .highlighted-black {
        color: #000;
        font-weight: 600;
    }

    .text-nowrap {
        white-space: nowrap;
    }

    .margin-left-5 {
        margin-left: 5px;
    }

    .red-text {
        color: #f00;
    }

    .radical-red {
        color: #FF4B55;
    }

    .deep-purple {
        color: #791C7E;
    }

    .charcoal-label {
        color: #aaa;
    }

    .text-royal-blue {
        color: #556BB8;
    }

    .text-slate-blue {
        color: #6C69CA;
    }

    .text-underline {
        text-decoration: underline;
    }

    .two-line-breaks {
        margin-top: 20px;
    }

    .opaque {
        opacity: 0.5;
        transition: all 0.3s;
    }

    .opaque:hover,
    .opaque.active {
        opacity: 1;
        cursor: pointer;
        transition: all 0.3s;
    }

    .font-18 {
        font-size: 18px;
    }

    .clickable-tab {
        cursor: pointer;
        opacity: 1;
    }

    .disabled-tab {
        cursor: not-allowed;
        opacity: 0.5;
    }

    .link-text {
        cursor: pointer;
        color: #556bb8;
        text-decoration: none;
        transition: width 2s linear 1s;
    }

    .link-text:hover {
        text-decoration: underline;
        transition: width 2s linear 1s;
    }

    .width-inherit {
        width: inherit;
    }

    .margin-0-auto {
        margin: 0 auto;
    }

    .margin-40-auto {
        margin: 40px auto;
    }

    .carousel-desc-width {
        max-width: 80% !important;
    }

    .payment-form .chakra-tabs {
        padding: 0px !important;
    }

    .align-center {
        align-items: center;
    }

    .break-word {
        word-break: break-word;
    }

    .ml-10 {
        margin-left: 10px;
    }

    .custom-tooltip-inner {
        background-color: #ededed;
        color: #555;
        padding: 10px 15px;
        border-radius: 5px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.5;
    }

    .chakra-tabs__tab-panels {
        padding: 0 !important;
    }
    .width-auto {
        width: auto !important;
    }
     .add-on-body{
        max-width: 1205px;
        margin: 0 auto !important;
     }
     .bundle-flex-body{
        max-width: 1250px !important;
        margin: 0 auto !important;
        width: auto;
     }
     .tooltip-inner{
        /* max-width: 30%; */
        word-break: break-word;
    }
    .flex-unset{
        flex: unset;
    }
    .date-picker-popover{
        min-width: 288px;
    }
    .datepicker-overlay-container .heading > div.text-center{
        align-items: center;
    }
    .datepicker-overlay-container .heading > div.text-center .pull-right, 
    .datepicker-overlay-container .heading > div.text-center .pull-left{
       height: 13px;
    }
    .default-text{
        color: #555;
    }
`;
